export default class RodoFormFieldsWFFMDataExchange {
  /**
   * 
   * @param {Element} form 
   */
  constructor (form) {
    this.formFields = form.querySelector('div').nextElementSibling
    this.emptyFieldsValue()
  }

  get data () {
    return this.formFields.querySelectorAll('.form-group').map((el, i) => ({
      id: i,
      enabled: true,
      el: this.formGroupInput(el),
      value: this.formGroupInput(el).value,
    }))
  }

  /**
   * @param {Array} value
   */
  set data (fields) {
    this.formFields.querySelectorAll('.form-group').forEach((el, i) => {
      const input = this.formGroupInput(el)

      if (fields[i].value !== input.value) {
        input.value = fields[i].value
      }
    })
  }

  formGroupInput (group) {
    return group.querySelector('.form-control')
  }

  emptyFieldsValue () {
    return this.formFields.querySelectorAll('.form-group').map(el => {
      this.formGroupInput(el).value = ''
    })
  }
}


// WEBPACK FOOTER //
// ./src/services/RodoFormFieldsWFFMDataExchange.js